import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross & Blue Shield of Mississippi",
  shortName: "BCBS Mississippi",
  slug: "bcbsms-insurance",
  seoTitle:
    "Blue Cross & Blue Shield of Mississippi TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross & Blue Shield of Mississippi policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBS Mississippi TMS coverage, Blue Cross Blue Shield Mississippi SPRAVATO authorization, BCBSMS mental health benefits Coral Springs FL, BCBS Mississippi depression treatment Florida",
};

export const BcbsmsInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbsmsInsurance;
